import React, { Component } from "react";
import SubmitFeed from "./Elements/SubmitFeed";
import { DEBOUNCE, VALIDATE_URL, isAppleSafari, showAddAccountAlertNew, TOAST_ERROR, isAccountConnected } from "../../../../../../../../../utils";
import { addUserAccount } from "../../../../../../../../Authorization/SocialAuth/connectSocialAcc";
import { MediaBaseUrl } from "../../../../../../../../../actions/api";
import Select from 'react-select';
import { AUTOCOMPLETE } from "../../../../../../../../../actions/manageFeedsAction";
import { connect } from 'react-redux';
import ConnectChildAccount from "./Elements/ConnectChildAccount";

const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

class FbFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            textField: '',
            account: null,
            albumUrl: '',
            errorMsg: 'This field is required',
            error: false,
            albumUrlError: false,
            album: { label: 'Single Album', value: '65' },
            connetedAccount: null,
            handles: [],
            showHandle: false,
            feedObj: {},
            accountList: []
        }
    }

    componentDidMount() {
        channel.addEventListener("message", this.readAuthenticationCode);
    }

    onTextFieldChange = value => this.setState({ textField: value, error: false })
    onAlbumFieldChange = value => this.setState({ albumUrl: value, albumUrlError: false });
    onAlbumChange = value => this.setState({ album: value })

    addFacebookAccount = () => {
        const feed = this.createFeedPostData();
        this.setState({feedObj : feed });
        showAddAccountAlertNew({ id: 3, name: "facebook" }, "addFeed", [62, 55].includes(this.props.selectedFilterId));
    }

    createFeedPostData = () => {
        const { textField, album, connetedAccount, account, albumUrl } = this.state;
        const { selectedFilterId } = this.props;

        var obj = {
            networkId: 3,
            filter: selectedFilterId == 67 ? parseInt(album.value) : selectedFilterId,
            connetedAccount: [62, 55].includes(selectedFilterId) ? connetedAccount : 0,
            account: [62, 55].includes(selectedFilterId) ? account : connetedAccount,
            field: textField,
            onlyReels: 0,
            hashtagIGTV: 0,
            moderation: 0,
        }
        if (selectedFilterId == 67) {
            obj['field'] = albumUrl;
        }
        if (![8, 67].includes(selectedFilterId)) {
            obj['field'] = '';
        }

        return obj;
    }

    createFeed = (connectAccountId) => {
        const { updateStep } = this.props;
        let obj = this.createFeedPostData();
        if (connectAccountId) {
            obj = { ...obj, account: connectAccountId };
        }
        this.setState({ loading: true, error: false, albumUrlError: false });

        updateStep(2, obj, () => this.setState({ loading: false }));
    }

    onSubmit = (isDisabledClick) => {
        const { textField, connetedAccount, albumUrl, accountList } = this.state;
        const { accountId, selectedFilterId, connectedAcc } = this.props;

        const isAccConnected = isAccountConnected({ connectedAcc, accountList, accountId, connetedAccount });

        if ([1, 55, 62].includes(selectedFilterId) && !isAccConnected) {
            TOAST_ERROR("Please connect your Facebook Account to proceed");
            return;
        }

        if ((!textField || textField == "") && selectedFilterId == 8) {
            this.setState({ error: true, errorMsg: 'This field is required' })
        } else if (selectedFilterId == 8 && !VALIDATE_URL(textField)) {
            this.setState({ error: true, errorMsg: 'Please enter valid Page Url' })
        } else if ((!albumUrl || albumUrl == "") && selectedFilterId == 67) {
            this.setState({ albumUrlError: true, errorMsg: 'This field is required' })
        } else if (selectedFilterId == 67 && !VALIDATE_URL(albumUrl)) {
            this.setState({ albumUrlError: true, errorMsg: 'Please enter valid Album Url' })
        } else {

            if (connetedAccount && accountId) {
                this.createFeed();
            } else {
                this.addFacebookAccount();
            }
        }
    }

    autoComplete = DEBOUNCE((value) => {
        const obj = { networkId: 3, handle: value }
            AUTOCOMPLETE(obj).then(res => {
                const { response, responseCode } = res.data;
                if (responseCode == 200) {
                    this.setState({ handles: response.data, showHandle: response.data.length > 0 })
                }
                else this.setState({ handles: [], showHandle: false })
            })
    });

    handleTextChange = value => {
        this.onTextFieldChange(value);
        const isPageUrl = value.includes('https://www.facebook.com/');
       
        if (value.length > 2 && !isPageUrl) {
            this.autoComplete(value)
        } else {
            this.setState({ showHandle: false,handles:[] })
        }
    }

    onSelectHandle = (item) => {
        this.setState({ showHandle: false, textField: item.link, error: false });
    }

    createFeedFromPage = (accId, parentId) => {
        const { updateStep } = this.props;
        let { feedObj } = this.state;
        
        feedObj = { ...feedObj, account: accId, connetedAccount: parentId }

        this.setState({ loading: true, error: false, albumUrlError: false });

        updateStep(2, feedObj, () => this.setState({ loading: false }));

    }

    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId, type } = response;
        const { selectedFilterId } = this.props;
        if (type == "addFeed") {
            addUserAccount(networkId, data, [55, 62].includes(selectedFilterId) ? (responseData) => this.setState({ accountList: responseData }) : (connectAccountId) => this.createFeed(connectAccountId), localStorage.getItem('ownerId'), selectedFilterId);
        }
    }

    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }


    render() {
        const { textField, albumUrl, album, handles, showHandle, error, albumUrlError, errorMsg, loading, accountList } = this.state;
        const { selectedFilterId, connectedAcc } = this.props;

        const isSubmitDisabled = selectedFilterId == 8 ? !textField.trim()
            : selectedFilterId == 67 ? !albumUrl.trim() 
            : false;

        return (
            (accountList && accountList.length > 0) && [1, 55, 62].includes(selectedFilterId) ?
            <ConnectChildAccount accountList={accountList} loading={loading} connectedAcc={connectedAcc} networkId={3} createFeedFromPage={this.createFeedFromPage} backAction={this.props.backAction} /> : <div className="ob-feed-form-wrapper w-100">
                {[1, 55, 62].includes(selectedFilterId) ? <div className="form-group text-start mb-4">
                    <div className="py-2">
                        <div className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3 cursor-pointer" onClick={this.addFacebookAccount}>
                            <span className="symbol symbol-25 me-3">
                                <img src={`${MediaBaseUrl}social-icons/facebook.svg`} />
                            </span>
                            <span className="text-dark-50 font-weight-bolder font-size-base">Connect Facebook</span>
                        </div>
                    </div>
                </div> :
                        <div className={`${selectedFilterId == 67 ? "d-flex" : ""} selectSource-right text-start mb-3`}>
                            {selectedFilterId == 67 ?
                                <div className="col-5 me-3">
                                    <Select className="selectpicker selectpicker-custom selectpicker-lg" options={[{ label: 'Single Album', value: '65' }, { label: 'All Facebook Page Albums', value: '67' }]} classNamePrefix="selectpicker" defaultValue={album} onChange={(e) => this.onAlbumChange(e)} />
                                </div> : null}
                            <div className={selectedFilterId == 67 ? "col-7" : ""}>
                                <div className="position-relative d-flex custom-input">
                                    <span className="hastag d-flex align-items-center">
                                        <i className="fa fa-flag"></i>
                                    </span>
                                    <input autoComplete="off" data-limit="100" placeholder={selectedFilterId == 8 ? "Enter page URL here.." : "Enter album URL here.."} value={selectedFilterId == 8 ? textField : albumUrl} className="autosearch mycheck form-control p-3" id={`${selectedFilterId == 8 ? 'Page' : 'Albums'}-text`} onChange={(e) => selectedFilterId == 8 ? this.handleTextChange(e.target.value) : this.onAlbumFieldChange(e.target.value)} type="text" />
                                    <div className="handlelist" id="" style={(showHandle && textField.length > 0) ? { display: "block" } : { display: "none" }}>
                                        <ul className="list-unstyled">
                                            {handles && handles.length ? handles.map((item) => (
                                                <li key={item.id} onClick={() => this.onSelectHandle(item)}>
                                                    <div className="content-section">
                                                        {item.name}
                                                        <p>{item.link}</p>
                                                    </div>
                                                </li>
                                            )) : null}
                                        </ul>
                                    </div>
                                </div>
                                {(selectedFilterId == 8 && error) || (selectedFilterId == 67 && albumUrlError) ? <span id="" className="errorMessage required">{errorMsg}</span> : null}
                            </div>
                        </div>
                }
                <div className="click-next d-flex align-items-center py-3 px-4 rounded justify-content-between">
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={isSubmitDisabled} />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        accountId: state.addFeedReducer.selectedAccount,
        connectedAcc: state.addFeedReducer.connectedAcc
    }
}

export default connect(mapStateToProps)(FbFeed);